import { render, staticRenderFns } from "./ModalFormPassword.vue?vue&type=template&id=0ecd54da&scoped=true&"
import script from "./ModalFormPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalFormPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ModalFormPassword.vue?vue&type=style&index=0&id=0ecd54da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd54da",
  null
  
)

export default component.exports